import Img4 from "../../../assets/img/image(4).png";
import Img5 from "../../../assets/img/image(5).png";
import Img6 from "../../../assets/img/image(6).png";
import Img7 from "../../../assets/img/image(7).jpg";
import Img8 from "../../../assets/img/image(8).jpg";
import Img9 from "../../../assets/img/image(9).jpg";
import Img10 from "../../../assets/img/image (10-1).jpg";
import Img11 from "../../../assets/img/image(11).jpg";
import MobileImg1 from "../../../assets/img/fan_mobile_img(1).png";
import { Tile } from '../../../components/Tile/Tile'
import Button from '../../../components/Button/Button';
import "./FanPage.css";
import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FavRequestModal from "../../../components/Modal/FavRequestModal/FavRequestModal";
import { IFavRequest } from "../../../types/types";
import { FavRequest } from "../../../services/favRequest.service";
import { handleMessage } from "../../../utils/handleMessagePopup";
import { trackEvent } from "../../../utils/ga";

const images = [Img8, Img9, Img10, Img11];
const FanPage: React.FC<{
  handleScrollToTop?: () => void;
}> = ({ handleScrollToTop }) => {
  const [state, setState] = useState({
    currentIndex: 3,
    formData: {
      favname: "",
      email: "",
    } as IFavRequest,
    isFavModalOpen: false
  })
  const swipeRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const getClass = (index: number) => {
    if (index === state.currentIndex) return "big"; // Active image (large)
    if (index === (state.currentIndex + 1) % images.length) return "small3";
    if (index === (state.currentIndex + 2) % images.length) return "small2";
    if (index === (state.currentIndex + 3) % images.length) return "small1";
    return "hide";
  };

  const handleNext = () => {
    setState((prev) => ({ ...prev, currentIndex: (prev.currentIndex + 1) % images.length }))
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleFavRequest = async () => {
    try {
      const response = await FavRequest(state.formData);
      if (response.error == null) {
        handleMessage("Request submitted successfully");
        setState((pre) => ({ ...pre, isFavModalOpen: false }));
        trackEvent(
          "submit_fav_request",
          JSON.stringify({ favname: state.formData.favname })
        );
      } else {
        handleMessage("Please send your request");
      }
    } catch {
      console.error("Unable to submit request");
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, formData: { ...prev.formData, [name]: value } }))
  };

  return (<>
    <div className="fan-page">
      <div className="main row my-5 mx-0">
        {/* LEFT - desktop only */}
        <div className="Left col-6 d-none d-md-flex justify-content-end">
          <div className="sub-left">
            <div className="bg-midnight p-5 d-flex h-100 flex-column justify-content-between gap-3 famHead">
              <div>
                <h1 className="heading font-500-44 line-height-120">The most exclusive fan experience in the world</h1>
                <p className="content font-500-30">
                  Win the singular, unmatched opportunity to become Fan1 to your favorite person, place, or thing.
                </p>
              </div>
              <div className="w-100">
                <Button
                  variant="primary"
                  className="fan-button p-3"
                  onClick={() => { navigate("/available") }}
                  label={"Browse Available Memberships"}
                />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT - image section */}
        <div className="col-md-6 p-0 m-0 position-relative">
          <img src={Img4} className="fan-img1 d-none d-md-block" alt="" />
          <img src={MobileImg1} className="fan-img1 d-block d-md-none" alt="" />

          {/* Mobile text overlay */}
          <div className="text-overlay d-flex d-md-none flex-column px-4 justify-content-end">
            <div>
              <div className="heading font-500-44 text-white my-4">The most exclusive fan experience in the world</div>
              <p className="content font-500-20 text-white mb-4">
                Win the singular, unmatched opportunity to become Fan1 to your favorite person, place, or thing.
              </p>
            </div>

            <Button
              variant="primary"
              className="mt-5 fan-button p-3 mb-4"
              onClick={() => { navigate("/available") }}
              label={"Browse Available Memberships"}
            />
          </div>
        </div>
      </div>

      <div className="container">
        <div className='fan-div-2 mt-80 bg-midnight position-relative overflow-hidden'>
          <h2 className="font-500-36 fan-head1">What is Fan1?</h2>
          <h4 className='text-light-purple mb-5 font-500-26 fan-head4'>
            Fan1 is the ultimate way for fans to interact one-on-one with their favorite athletes, musicians, actors, and more. Only one Fan1 at a time—no one else in the world gets this access simultaneously.  The approach is so unique that we filed a patent.
          </h4>
          <h4 className="font-500-26 fan-head4">Key Features:</h4>
          <ul className="px-4">
            <li>
              <div className="pb-2">
                <span className="font-700-15"> Exclusive fan1 membership </span>
                <span className="font-inter-300-15"> {" "} - No one else can hold it at the same time. </span>
              </div>
            </li>
            <li>
              <div className="pb-2">
                <span className="font-700-15"> Verified public figures </span>
                <span className="font-300-15"> {" "} - No AI, no bots, just real connections. </span>
              </div>
            </li>
            <li>
              <div className="pb-2">
                <span className="font-700-15">Public and private interaction </span>
                <span className="font-inter-300-15"> {" "} - Engage on a public message board and send exclusive private messages.{" "}
                </span>
              </div>
            </li>
            <li>
              <div>
                <span className="font-700-15"> Recurring auctions </span>
                <span className="font-inter-300-15"> {" "} - Bid confidentially and win the Fan1 title. </span>
              </div>
            </li>
          </ul>
          <div className="fan-internal-ellipse"></div>
        </div>

        <div className='fan-div-2 mt-80 bg-midnight position-relative'>
          <h2 className="font-500-36 mb-4 fan-head1">Why Become Fan1?</h2>
          <div className='fan-row'>
            <div className='column-3 position-relative'>
              <h4 className='mb-4 font-500-26 fan-head4'>Get noticed by your favorite public figure</h4>
              <p className="font-inter-300-15">This isn’t just another fan club. As Fan1, you hold an exclusive connection with your favorite celebrity, directly engaging with them in a way no one else can.</p>
            </div>
            <div className='column-3 position-relative'>
              <h4 className='mb-4 font-500-26 fan-head4'>A social status no one else can claim</h4>
              <p className="font-inter-300-15">This is the rarest membership in the world—while you hold it, no one else can. You’re the only Fan1.</p>
            </div>
            <div className='column-3 position-relative'>
              <h4 className='mb-4 font-500-26 fan-head4'>Share the spotlight</h4>
              <p className="font-inter-300-15">Your name is attached to your favorite public figure for a moment in time. Everyone will know you are Fan1.</p>
            </div>
            <div className='column-3 position-relative'>
              <h4 className='mb-4 font-500-26 fan-head4'>A one-of-a-kind experience</h4>
              <p className="font-inter-300-15">No two Fan1 experiences are the same. Each interaction is unique, unrepeatable, and completely yours.</p>
            </div>
          </div>
          <div className="static-ellipse-left"></div>
        </div>

        <div className='fan-div-2 mt-80 bg-midnight position-relative'>
          <h2 className="font-500-36 mb-4 fan-head1">How It Works</h2>
          <div className='fan-row mt-3'>
            <div className='column-3 position-relative'>
              <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9336 17.1094C11.6289 17.4141 11.0703 17.4141 10.7656 17.1094L7.92188 14.2656C7.61719 13.9609 7.61719 13.4023 7.92188 13.0977C8.22656 12.793 8.78516 12.793 9.08984 13.0977L11.375 15.3828L16.4531 10.2539C16.7578 9.94922 17.3164 9.94922 17.6211 10.2539C17.9258 10.5586 17.9258 11.1172 17.6211 11.4219L11.9336 17.1094ZM17.418 2.58594C19.0938 2.28125 20.8711 2.78906 22.1914 4.05859C23.4609 5.37891 23.9688 7.15625 23.6641 8.83203C25.0352 9.79688 26 11.4219 26 13.25C26 15.1289 25.0352 16.7031 23.6641 17.7188C23.9688 19.3945 23.4609 21.1719 22.1914 22.4414C20.8711 23.7617 19.0938 24.2695 17.418 23.9648C16.4531 25.3359 14.8281 26.25 13 26.25C11.1211 26.25 9.49609 25.3359 8.53125 23.9648C6.85547 24.2695 5.07812 23.7617 3.75781 22.4414C2.48828 21.1719 1.98047 19.3945 2.28516 17.7188C0.914062 16.7031 0 15.1289 0 13.25C0 11.4219 0.914062 9.79688 2.28516 8.83203C1.98047 7.15625 2.48828 5.37891 3.75781 4.05859C5.07812 2.78906 6.85547 2.28125 8.53125 2.58594C9.49609 1.21484 11.1211 0.25 12.9492 0.25C14.8281 0.25 16.4531 1.21484 17.418 2.58594ZM9.34375 4.51562L8.68359 4.3125C7.41406 3.90625 5.94141 4.21094 4.92578 5.22656C3.91016 6.24219 3.60547 7.71484 4.01172 8.98438L4.21484 9.64453L3.60547 9.94922C2.38672 10.5586 1.625 11.8281 1.625 13.25C1.625 14.7227 2.38672 15.9414 3.60547 16.6016L4.21484 16.9062L4.01172 17.5664C3.60547 18.8359 3.91016 20.3086 4.92578 21.3242C5.94141 22.3398 7.41406 22.6445 8.68359 22.2383L9.34375 22.0352L9.64844 22.6445C10.3086 23.8633 11.5273 24.625 13 24.625C14.4219 24.625 15.6406 23.8633 16.3008 22.6445L16.6055 22.0352L17.2656 22.2383C18.5352 22.6445 20.0078 22.3398 21.0234 21.3242C22.0391 20.3086 22.3438 18.8359 21.9375 17.5664L21.7344 16.9062L22.3438 16.6016C23.5625 15.9414 24.375 14.7227 24.375 13.25C24.375 11.8281 23.5625 10.5586 22.3438 9.94922L21.7344 9.64453L21.9375 8.98438C22.3438 7.71484 22.0391 6.24219 21.0234 5.22656C20.0078 4.21094 18.5352 3.90625 17.2656 4.3125L16.6055 4.51562L16.3008 3.90625C15.6406 2.6875 14.4219 1.875 13 1.875C11.5273 1.875 10.3086 2.6875 9.64844 3.90625L9.34375 4.51562Z" fill="#CBC0EA" />
              </svg>
              <h3 className='mt-3 mb-4 font-500-26 fan-head4'>Stringent verification</h3>
              <p className="font-inter-300-15">Every public figure on Fan1 is verified.</p>
              <p className="font-inter-300-15"> No AI, no bots. </p>
              <p>What you see is real.</p>
            </div>
            <div className='column-3 position-relative'>
              <svg width="32" height="27" viewBox="0 0 32 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.6875 6.34375C20.1445 6.39453 20.5 6.69922 20.6016 7.15625C20.7539 7.5625 20.6523 8.01953 20.3477 8.32422L18.7734 9.79688L19.1797 11.9297C19.2305 12.3867 19.0781 12.793 18.7227 13.0469C18.5195 13.1992 18.2656 13.25 18.0117 13.25C17.8594 13.25 17.6562 13.25 17.5039 13.1484L15.5742 12.1328L13.6953 13.1484C13.2891 13.3516 12.832 13.3008 12.4766 13.0469C12.1211 12.793 11.9688 12.3867 12.0195 11.9297L12.4258 9.79688L10.8516 8.32422C10.5469 8.01953 10.4453 7.5625 10.5977 7.15625C10.6992 6.69922 11.0547 6.44531 11.5117 6.34375L13.6445 6.03906L14.5586 4.10938C14.9648 3.34766 16.2344 3.34766 16.6406 4.10938L17.5547 6.03906L19.6875 6.34375ZM17.0469 9.23828L18.4688 7.81641L16.4883 7.5625L15.625 5.73438L14.7109 7.5625L12.7305 7.81641L14.1523 9.23828L13.7969 11.2188L15.5742 10.3047L17.4023 11.2188L17.0469 9.23828ZM30.0469 4.16016C30.0977 4.36328 31.1133 9.44141 27.9141 14.1133C25.7812 17.2617 22.3281 19.3945 17.6055 20.5625C16.8945 20.7656 16.3867 21.375 16.3867 22.1367V24.625H21.2617C21.7188 24.625 22.0234 25.0312 22.0234 25.4375C22.0234 25.8945 21.668 26.25 21.2617 26.25H9.9375C9.48047 26.25 9.07422 25.8945 9.07422 25.4375C9.07422 25.0312 9.48047 24.625 9.9375 24.625H14.7617V22.1367C14.7617 21.375 14.2539 20.7148 13.543 20.5625C8.82031 19.3945 5.36719 17.2617 3.28516 14.1133C0.0859375 9.44141 1.10156 4.36328 1.15234 4.16016C1.25391 3.80469 1.55859 3.5 1.96484 3.5H7.5C7.5 3.19531 7.5 2.89062 7.5 2.63672C7.5 1.31641 8.61719 0.25 9.9375 0.25H21.2617C22.582 0.25 23.6992 1.31641 23.6992 2.63672C23.6992 2.89062 23.6992 3.19531 23.6992 3.5H29.2344C29.6406 3.5 29.9453 3.80469 30.0469 4.16016ZM4.60547 13.25C6.12891 15.4844 8.51562 17.1602 11.6133 18.2773C8.51562 14.7227 7.65234 9.08594 7.5 5.125H2.67578C2.52344 6.54688 2.47266 10.0508 4.60547 13.25ZM15.625 19.293C21.7695 16.5508 22.1758 6.80078 22.0742 2.6875C22.0742 2.23047 21.7188 1.875 21.2617 1.875H9.9375C9.48047 1.875 9.125 2.23047 9.125 2.6875C9.02344 6.80078 9.42969 16.5508 15.625 19.293ZM26.5938 13.25C28.7266 10.0508 28.6758 6.54688 28.5234 5.125H23.6992C23.5469 9.08594 22.6836 14.7227 19.5859 18.2773C22.6836 17.1602 25.0703 15.4844 26.5938 13.25Z" fill="#CBC0EA" />
              </svg>
              <h3 className='mt-3 mb-4 font-500-26 fan-head4'>Winning an auction</h3>
              <p className="font-inter-300-15">Bid any amount over $10.</p>
              <p className="font-inter-300-15">Auctions are blind, so no one sees other bids.</p>
              <p className="font-inter-300-15">Highest bid wins, and that fan becomes Fan1.</p>
            </div>
            <div className='column-3 position-relative'>
              <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.4844 13.8594C20.4492 13.9609 20.8047 15.1289 20.1445 15.8398L16.2852 19.5977L17.1992 24.9297C17.25 25.2344 17.1484 25.5898 16.8945 25.8438C16.6914 26.0977 16.3867 26.25 16.0312 26.25C15.8281 26.25 15.625 26.1992 15.4727 26.1484L10.75 23.6094L5.97656 26.1484C5.77344 26.25 5.62109 26.25 5.41797 26.25C5.0625 26.25 4.75781 26.0977 4.55469 25.8438C4.35156 25.5898 4.25 25.2344 4.30078 24.9297L5.16406 19.5977L1.35547 15.8398C0.644531 15.1797 1 13.9609 1.96484 13.8594L7.29688 13.0469L9.68359 8.22266C9.88672 7.81641 10.293 7.5625 10.6992 7.5625C11.1562 7.5625 11.5625 7.81641 11.7656 8.22266L14.1523 13.0469L19.4844 13.8594ZM14.5078 19.0391L18.3164 15.332L13.0859 14.5703L10.75 9.79688L8.36328 14.5703L3.13281 15.332L6.89062 19.0391L6.02734 24.2695L10.6992 21.7812L15.4219 24.2695L14.5078 19.0391ZM14 5.9375C13.543 5.9375 13.1875 5.58203 13.1875 5.125C13.1875 4.71875 13.543 4.3125 14 4.36328L17.25 4.3125V1.0625C17.25 0.65625 17.6055 0.25 18.0625 0.25C18.4688 0.25 18.875 0.65625 18.875 1.0625V4.3125L22.125 4.36328C22.5312 4.36328 22.9375 4.71875 22.9375 5.125C22.9375 5.58203 22.5312 5.9375 22.125 5.9375H18.875V9.1875C18.875 9.64453 18.4688 10 18.0625 10C17.6055 10 17.25 9.64453 17.25 9.1875V5.9375H14ZM26.1875 10.8125C26.5938 10.8125 27 11.2188 27 11.6758C27 12.082 26.5938 12.4375 26.1875 12.4375H24.5625V14.0625C24.5625 14.5195 24.1562 14.9258 23.75 14.9258C23.293 14.9258 22.9375 14.5195 22.9375 14.0625V12.4375H21.3125C20.8555 12.4375 20.5 12.082 20.5 11.6758C20.5 11.2188 20.8555 10.8125 21.3125 10.8125H22.9375V9.1875C22.9375 8.78125 23.3438 8.42578 23.75 8.42578C24.1562 8.42578 24.5625 8.78125 24.5625 9.1875V10.8125H26.1875Z" fill="#CBC0EA" />
              </svg>
              <h3 className='mt-3 mb-4 font-500-26 fan-head4'>What you get as fan1</h3>
              <p className="font-inter-300-15">Your exclusive title as Fan1.</p>
              <p className="font-inter-300-15">The ability to send private messages (limited quantity).</p>
              <p className="font-inter-300-15">A public message board to interact with your public figure.</p>
            </div>
            <div className='column-3 position-relative'>
              <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.67188 0.25C5.89062 0.25 7.00781 0.757812 7.82031 1.51953C8.17578 1.82422 8.17578 2.33203 7.87109 2.6875C7.56641 2.99219 7.05859 3.04297 6.75391 2.73828C6.19531 2.23047 5.48438 1.875 4.67188 1.875C2.94531 1.875 1.625 3.24609 1.625 4.97266C1.625 5.58203 1.77734 6.14062 2.08203 6.59766C2.33594 6.95312 2.18359 7.46094 1.82812 7.71484C1.47266 7.96875 0.964844 7.86719 0.710938 7.46094C0.253906 6.75 0 5.88672 0 4.97266C0 2.38281 2.08203 0.25 4.67188 0.25ZM18.1289 1.51953C18.9414 0.757812 20.0586 0.25 21.2773 0.25C23.8672 0.25 26 2.38281 26 4.97266C26 5.88672 25.6953 6.75 25.2383 7.46094C24.9844 7.86719 24.4766 7.96875 24.1211 7.71484C23.7656 7.46094 23.6133 6.95312 23.8672 6.59766C24.1719 6.14062 24.375 5.58203 24.375 4.97266C24.375 3.24609 23.0039 1.875 21.2773 1.875C20.4648 1.875 19.7539 2.23047 19.1953 2.73828C18.8906 3.04297 18.3828 2.99219 18.0781 2.6875C17.7734 2.33203 17.7734 1.82422 18.1289 1.51953ZM13.8125 15.2812L16.707 17.5156C17.0625 17.7695 17.1641 18.2773 16.8594 18.6328C16.6055 18.9883 16.0977 19.0898 15.7422 18.7852L12.4922 16.3477C12.2891 16.1953 12.1367 15.9414 12.1367 15.6875V9.1875C12.1367 8.78125 12.543 8.375 12.9492 8.375C13.4062 8.375 13.8125 8.78125 13.8125 9.1875V15.2812ZM1.82812 26.0469C1.52344 25.7422 1.52344 25.1836 1.82812 24.8789L4.36719 22.3398C2.64062 20.3594 1.625 17.7695 1.625 14.875C1.625 8.62891 6.70312 3.5 13 3.5C19.2461 3.5 24.375 8.62891 24.375 14.875C24.375 17.7695 23.3086 20.3594 21.582 22.3398L24.1211 24.8789C24.4258 25.1836 24.4258 25.7422 24.1211 26.0469C23.8164 26.3516 23.2578 26.3516 22.9531 26.0469L20.4141 23.5078C18.4336 25.2344 15.8438 26.25 13 26.25C10.1055 26.25 7.51562 25.2344 5.53516 23.5078L2.99609 26.0469C2.69141 26.3516 2.13281 26.3516 1.82812 26.0469ZM12.9492 24.625C18.3828 24.625 22.75 20.2578 22.75 14.875C22.75 9.49219 18.3828 5.125 12.9492 5.125C7.56641 5.125 3.19922 9.49219 3.19922 14.875C3.19922 20.2578 7.56641 24.625 12.9492 24.625Z" fill="#CBC0EA" />
              </svg>
              <h3 className='mt-3 mb-4 font-500-26 fan-head4'>What happens when your fan1 time ends?</h3>
              <p className="font-inter-300-15">Your name remains in the Fan1 history log.</p>
              <p className="font-inter-300-15">A new auction starts. You can bid again to remain Fan1.</p>
              <p className="font-inter-300-15">If outbid, your private messages go to read-only, but you had an incredible experience.</p>
            </div>
          </div>
          <div className="static-ellipse-right"></div>
        </div>

        <div className="fan-div-2 bg-midnight d-flex flex-column flex-lg-row mt-80 discover-tile position-relative">
          <div className="col-12 col-lg-6 p-60-80 mb-4 mb-lg-0">
            <h2 className="font-500-36 mb-3">Discover other memberships</h2>
            <h3 className='text-light-purple mb-5 font-500-26 font-inter'>
              Fan1 isn’t just for living celebrities. Claim historical figures, fictional characters, places, and things.
            </h3>
            <h3 className="font-500-26 mb-3">How it works for fictional & historical memberships</h3>
            <ul className="px-4">
              <li className="font-inter-300-15 mb-3">The experience functions the same, but no private messaging.</li>
              <li className="font-inter-300-15 mb-3">The public message board is yours to share your thoughts, appreciation, and insights.</li>
              <li className="font-inter-300-15">Own your place in history as the biggest fan of everything you love.</li>
            </ul>
          </div>

          <div className="col-12 col-lg-6 p-0 m-0">
            <div className="carousel-container">
              <ul className="fan-list">
                {images.map((img, idx) => (
                  <li key={idx} className={getClass(idx)}>
                    <img src={img} alt={`Slide ${idx}`} className="slides-img" />
                  </li>
                ))}
              </ul>
              <div className="swipe" ref={swipeRef}></div>
            </div>
          </div>
          <div className="static-ellipse-left"></div>
        </div>

        <div className='mt-80'>
          <h2 className="font-500-36 mb-md-4">Ready to become fan1?</h2>
          <div className="tile-block p-0">
            <Tile
              src={Img5}
              alt="tile image"
              title="Browse available memberships"
              content="See whats new and available."
              btnLabel="View Available Memberships"
              btnClass="fan-button"
              onClick={() => { navigate("/available") }}
            />
            <Tile
              src={Img6}
              alt="tile image2"
              title="Find and follow your favorites"
              content="Stay up to date on all your favorites."
              btnLabel='Search for Public Figures & Follow'
              btnClass="fan-button"
              onClick={handleScrollToTop}
            />
            <Tile
              src={Img7}
              alt="tile image3"
              title="Request a new membership"
              content="Can’t find what you adore?"
              btnLabel="Request Now"
              btnClass="fan-button"
              onClick={() => { setState((prev) => ({ ...prev, isFavModalOpen: true })) }}
            />
          </div>
        </div>
      </div>
    </div>

    <FavRequestModal
      isVisible={state.isFavModalOpen}
      data={state.formData}
      onClick={handleFavRequest}
      onClose={() => setState((prev) => ({ ...prev, isFavModalOpen: false }))}
      handleInputChange={handleInputChange}
    /></>
  )
}

export default FanPage

